import { render, staticRenderFns } from "./BloqueioEmpresa.vue?vue&type=template&id=bb547376&"
import script from "./BloqueioEmpresa.vue?vue&type=script&lang=js&"
export * from "./BloqueioEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports